/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import Pagination from '../../../../components/Pagination';

export default function Table({ tableData, List, searchParams, handleOnClickPageNumber, isDisabled, isFiltersApplied }) {

    const subjectNames = (data, key, id) => {
        let arr = [];
        data[key]?.map((val) => {
            arr.push(val[id])

        })
        return arr.join(', ')
    }

    return (
        <>

            <div className="-mx-1">
                <div className="flex overflow-auto pb-[6px] scroll-bar px-1" id="search-result">
                    <table aria-label="Outside Table" className="w-full" id="admin-table">
                        <thead>
                            <tr>
                                <th className="w-[13%]">
                                    <span className="text-start">Class
                                    </span>
                                </th>
                                <th className="w-[13%]">
                                    <span className="text-start">Sections
                                    </span>
                                </th>
                                <th className="w-[24%]">
                                    <span className="text-start">Subjects
                                    </span>
                                </th>
                                <th className="w-[24%]">
                                    <span className="text-start">Exams
                                    </span>
                                </th>
                                <th className="w-[24%]">
                                    <span className="text-start">Teachers
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {isFiltersApplied && tableData?.map((table) => (
                                <>
                                    <tr key={table._id}>
                                        <td className="text-start">
                                            {table.class_name}
                                        </td>
                                        <td className="text-start">{table.section_name}</td>
                                        <td className="text-start">
                                            {subjectNames(table, 'subjects', 'subject_name') || '-'}
                                        </td>
                                        <td className="text-start"> {subjectNames(table, 'exams', 'exam_name') || '-'}  </td>
                                        <td className="text-start">
                                            {subjectNames(table, 'teachers', 'teacher_name') || '-'}
                                        </td>
                                    </tr>
                                </>
                            ))}
                        </tbody>
                        {(tableData === undefined || (tableData !== undefined && tableData?.length === 0) || !isFiltersApplied) && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px' }} colspan="5" className="no-records-message" id='no-matching-result'>
                                        {!isFiltersApplied ? `Select the ‘Academic Year’ and ‘Class’ to view the association` : (!isDisabled ? "No Association available for the AY and Class. Click 'Manage Association' to add." : "No Association available.")}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            {(List.total_count > 10) && <Pagination
                TotalCount={List.total_count}
                totalPageNumber={Math.ceil(List.total_count / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}

        </>
    )
}
